import React from 'react';
import PropTypes from 'prop-types';
import { TermsModal } from 'components';
import { Markdown } from 'Common';
import markdownContent from '!!raw-loader!static/health_benefit.md';

HealthBenefitLink.propTypes = {
  classNames: PropTypes.string,
  renderAs: PropTypes.string
};

export function HealthBenefitLink({ classNames, renderAs = 'button' }) {
  return (
    <TermsModal
      buttonClasses={classNames}
      modalHeaderText="Gesundheitlicher Nutzen"
      buttonText="Gesundheitlicher Nutzen"
      renderAs={renderAs}
    >
      <Markdown className="popup" containerId="modal-body" scrollOffset={0}>{markdownContent}</Markdown>
    </TermsModal>
  );
}
